module.exports = __webpack_public_path__ + "img/challenge.d0d25111.jpg";